// extracted by mini-css-extract-plugin
export var story__secondSectionImage = "storySecondSection-module--story__secondSectionImage--aY0DK";